import { render, staticRenderFns } from "./SideMenuLayout.vue?vue&type=template&id=016c5f68"
import script from "./SideMenuLayout.vue?vue&type=script&lang=js"
export * from "./SideMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports